module.exports = __webpack_public_path__ + "img/mvt_create.48ffa490.png";